import React from "react";
import ResetPasswordComponent from "../../features/auth/forgetPassword/ResetPassword";

function ResetPassword() {
  return (
    <div>
      <ResetPasswordComponent />
    </div>
  );
}

export default ResetPassword;
